"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "@/components/ui/Link";
import { FaRegBookmark, FaRegCommentDots } from "react-icons/fa";
import FourIconBar from "../ui/MessagePrint";
import PremiumBadge from "../ui/PremiumBadge";
import ImageWithText from "../ui/imagewithtext";
import { ImageMetadata } from '@/lib/componentutills';
import SocialIcons from "@/components/header/SocialIcons";
import Publishon from "@/components/ui/publishon";
import MessagePrint from "../ui/MessagePrint";
import { MessageIconLogo } from "../ui/message-icon-logo";
import ArticleShareButtons from "@/components/component_unique/ArticleShareButtons";
type Props = {
  category?: string;
  sectionUrl?: string;
  title?: string;
  excerpt?: string;
  imageSrc?: string;
  imageCaption?: string;
  imageAttribution?: string;
  imageMetadata?: ImageMetadata;
  publishedAt?: string;
  updatedAt?: string;
  showPublished?: boolean;
  slug?: string;
  articleUrl?: string;
  /** Mark the hero image as the LCP candidate — eager-load + fetchPriority=high. */
  priority?: boolean;
};
export default function BigNewsWithicon(t0) {
  const $ = _c(44);
  const {
    category: t1,
    sectionUrl,
    title: t2,
    excerpt: t3,
    imageSrc: t4,
    imageCaption,
    imageAttribution,
    imageMetadata,
    publishedAt,
    updatedAt,
    showPublished: t5,
    slug,
    articleUrl,
    priority: t6
  } = t0;
  const category = t1 === undefined ? "INDIA" : t1;
  const title = t2 === undefined ? "\"\u0BB0\u0BAF\u0BBF\u0BB2\u0BCD \u0BB5\u0BBF\u0BAA\u0BA4\u0BCD\u0BA4\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BBF\u0BA9\u0BCD\u0BA9\u0BA3\u0BC1 \u0B87\u0BA3\u0BC8\u0BAA\u0BCD\u0BAA\u0BC1 \u0B95\u0BCB\u0BB3\u0BBE\u0BB1\u0BC7 \u0B95\u0BBE\u0BB0\u0BA3\u0BAE\u0BCD...\"- \u0BB0\u0BAF\u0BBF\u0BB2\u0BCD\u0BB5\u0BC7 \u0B85\u0BAE\u0BC8\u0B9A\u0BCD\u0B9A\u0BB0\u0BCD \u0BA4\u0B95\u0BB5\u0BB2\u0BCD..!" : t2;
  const excerpt = t3 === undefined ? "\u0BAE\u0BC7\u0BB1\u0BCD\u0B95\u0BC1\u0BB5\u0B99\u0BCD\u0B95 \u0BAE\u0BBE\u0BA8\u0BBF\u0BB2\u0BAE\u0BCD \u0BB7\u0BBE\u0BB2\u0BBF\u0BAE\u0BB0\u0BBF\u0BB2\u0BCD \u0B87\u0BB0\u0BC1\u0BA8\u0BCD\u0BA4\u0BC1 \u0B9A\u0BC6\u0BA9\u0BCD\u0BA9\u0BC8 \u0BA8\u0BCB\u0B95\u0BCD\u0B95\u0BBF \u0BB5\u0BA8\u0BCD\u0BA4 \u0B95\u0BCB\u0BB0\u0BAE\u0BA3\u0BCD\u0B9F\u0BB2\u0BCD \u0BB5\u0BBF\u0BB0\u0BC8\u0BB5\u0BC1 \u0BB0\u0BAF\u0BBF\u0BB2\u0BCD, \u0B92\u0B9F\u0BBF\u0B9A\u0BBE \u0BAE\u0BBE\u0BA8\u0BBF\u0BB2\u0BAE\u0BCD \u0BAA\u0BBE\u0BB2\u0B9A\u0BCB\u0BB0\u0BCD \u0BB0\u0BAF\u0BBF\u0BB2\u0BCD \u0BA8\u0BBF\u0BB2\u0BC8\u0BAF\u0BAE\u0BCD \u0B85\u0BB0\u0BC1\u0B95\u0BC7 \u0B9A\u0BC6\u0BA9\u0BCD\u0BB1 \u0B9A\u0BBF\u0BB2 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD \u0B95\u0BCB\u0BB0\u0BAE\u0BA3\u0BCD\u0B9F\u0BB2\u0BCD \u0BB5\u0BBF\u0BB0\u0BC8\u0BB5\u0BC1 \u0BB0\u0BAF\u0BBF\u0BB2\u0BCD, \u0B92\u0B9F\u0BBF\u0B9A\u0BBE \u0BAE\u0BBE\u0BA8\u0BBF\u0BB2\u0BAE\u0BCD \u0BAA\u0BBE\u0BB2\u0B9A\u0BCB\u0BB0\u0BCD \u0BB0\u0BAF\u0BBF\u0BB2\u0BCD \u0BA8\u0BBF\u0BB2\u0BC8\u0BAF\u0BAE\u0BCD \u0B85\u0BB0\u0BC1\u0B95\u0BC7 \u0B9A\u0BC6\u0BA9\u0BCD\u0BB1 \u0B9A\u0BBF\u0BB2 " : t3;
  const imageSrc = t4 === undefined ? "https://media.dinamani.com/dinamani/2025-11-17/z8qqpdrb/erd17manu_1711chn_124_3.jpg" : t4;
  const showPublished = t5 === undefined ? true : t5;
  const priority = t6 === undefined ? false : t6;
  let t7;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <style>{"\n        @media (max-width: 767px) {\n          .bnwi-title { font-size: 20px !important; font-weight: 700 !important; font-family: var(--font-tamil) !important; }\n        }\n      "}</style>;
    $[0] = t7;
  } else {
    t7 = $[0];
  }
  let t8;
  if ($[1] !== category || $[2] !== sectionUrl) {
    t8 = category ? sectionUrl ? <Link href={sectionUrl} className="text-16-tamil-600 text-012061 tracking-wide uppercase hover:underline 1">{category?.trim() === "\u0BB5\u0BBF\u0BB3\u0BAE\u0BCD\u0BAA\u0BB0\u0BA4\u0BBE\u0BB0\u0BB0\u0BCD \u0B9A\u0BC6\u0BAF\u0BCD\u0BA4\u0BBF\u0B95\u0BB3\u0BCD" ? "" : category}</Link> : <div className="text-16-tamil-600 text-012061 tracking-wide uppercase">{category}</div> : <div />;
    $[1] = category;
    $[2] = sectionUrl;
    $[3] = t8;
  } else {
    t8 = $[3];
  }
  const t9 = `article-${slug || ""}`;
  const t10 = articleUrl || (slug ? `/${slug}` : undefined);
  let t11;
  if ($[4] !== excerpt || $[5] !== imageSrc || $[6] !== slug || $[7] !== t10 || $[8] !== t9 || $[9] !== title) {
    t11 = <div className="flex items-center gap-1 text-4D4D4D"><MessageIconLogo id={t9} variant="message-icon-3" slug={slug} title={title} thumbnailUrl={imageSrc} description={excerpt} articleUrl={t10} /></div>;
    $[4] = excerpt;
    $[5] = imageSrc;
    $[6] = slug;
    $[7] = t10;
    $[8] = t9;
    $[9] = title;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  let t12;
  if ($[11] !== t11 || $[12] !== t8) {
    t12 = <div className="flex justify-between items-center text-012061 text-16-english-600">{t8}{t11}</div>;
    $[11] = t11;
    $[12] = t8;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== title) {
    t13 = <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4"><h1 className="text-012061 text-32-tamil-700 md:text-16-tamil-700 bnwi-title leading-[1.5] tracking-wide flex-1">{title}</h1></div>;
    $[14] = title;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== excerpt) {
    t14 = <h2 className="text-020202 text-18-tamil-400 md:text-12-tamil-400 leading-[1.5]">{excerpt}</h2>;
    $[16] = excerpt;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] !== t12 || $[19] !== t13 || $[20] !== t14) {
    t15 = <div className="flex flex-col gap-4">{t12}{t13}{t14}</div>;
    $[18] = t12;
    $[19] = t13;
    $[20] = t14;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] !== imageAttribution || $[23] !== imageCaption || $[24] !== imageMetadata || $[25] !== imageSrc || $[26] !== priority) {
    t16 = imageSrc && <><ImageWithText text="" imageSrc={imageSrc} imageMetadata={imageMetadata} fixedHeight={true} priority={priority} />{(imageCaption || imageAttribution) && <div className="p-2 text-12-tamil-400 sm:text-16-tamil-400"><p>{imageCaption && <span className="text-12-tamil-600 text-black">{imageCaption}</span>}{imageCaption && imageAttribution && " - "}{imageAttribution && <span style={{
            color: "#00000099"
          }}>{imageAttribution}</span>}</p></div>}</>;
    $[22] = imageAttribution;
    $[23] = imageCaption;
    $[24] = imageMetadata;
    $[25] = imageSrc;
    $[26] = priority;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  const t17 = publishedAt || "08 May 2023 , 10:30 AM";
  const t18 = updatedAt || "08 May 2023 , 10:30 AM";
  let t19;
  if ($[28] !== showPublished || $[29] !== t17 || $[30] !== t18) {
    t19 = <div className="w-full sm:w-auto text-11-tamil-300 text-1B1B1B line-clamp-1"><Publishon publishedOn={t17} updatedOn={t18} showPublished={showPublished} /></div>;
    $[28] = showPublished;
    $[29] = t17;
    $[30] = t18;
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  const t20 = slug || "";
  let t21;
  if ($[32] !== t20 || $[33] !== title) {
    t21 = <div className="w-full sm:w-auto"><ArticleShareButtons slug={t20} title={title} className="!p-0 !gap-1" /></div>;
    $[32] = t20;
    $[33] = title;
    $[34] = t21;
  } else {
    t21 = $[34];
  }
  let t22;
  if ($[35] !== t19 || $[36] !== t21) {
    t22 = <div className="mt-4 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">{t19}{t21}</div>;
    $[35] = t19;
    $[36] = t21;
    $[37] = t22;
  } else {
    t22 = $[37];
  }
  let t23;
  if ($[38] !== t16 || $[39] !== t22) {
    t23 = <div className="w-full">{t16}{t22}</div>;
    $[38] = t16;
    $[39] = t22;
    $[40] = t23;
  } else {
    t23 = $[40];
  }
  let t24;
  if ($[41] !== t15 || $[42] !== t23) {
    t24 = <article className="flex flex-col overflow-hidden p-4 gap-4">{t7}{t15}{t23}</article>;
    $[41] = t15;
    $[42] = t23;
    $[43] = t24;
  } else {
    t24 = $[43];
  }
  return t24;
}